import Lock from './lock.svg';
import MagicMomentsDead from './magic-moments-dead.svg';
import MagicMomentsError from './magic-moments-error.svg';
import MagicMomentsRage from './magic-moments-rage.svg';
import Quotes from './quotes.svg';

export default {
  'highlights/lock': Lock,
  'highlights/magic-moments-dead': MagicMomentsDead,
  'highlights/magic-moments-error': MagicMomentsError,
  'highlights/magic-moments-rage': MagicMomentsRage,
  'highlights/quotes': Quotes,
};
